import { useState } from "react";
import "./ClaimCard.css";
import CubeSvg from "../retailer/pages/orders/svgs/CubeSvg";
import ButtonDownSvg from "../retailer/pages/orders/svgs/ButtonDownSvg";
import { AboutImg } from "../../images/Images";
import ClaimModal from "../retailer/pages/orders/component/ClaimModal";
import GradientButton from "../../components/button/Button";
import Modal from "../../components/modal/Modal";

interface OrderCardProps {
  orderId: string;
  amount: number;
  orderDate: string;
  items: number;
  shippingDetails: {
    name: string;
    address: string;
    phone: string;
  };
  orderStatus: {
    status: string;
    date: string;
  }[];
  orderItems: {
    name: string;
    price: number;
    quantity: number;
    image?: string;
  }[];
}

const dummyClaimInfo = {
  reason: "Damaged Product",
  details:
    "The product arrived completely damaged and couldn’t be used at all. The packaging was torn, the item itself was broken in several places, and it was far from the condition I expected. I was really disappointed because I had been looking forward to using it, but it showed up unusable right out of the box.",
  contact: "user@email.com",
  images: [
    "https://via.placeholder.com/70x70?text=Img1",
    "https://via.placeholder.com/70x70?text=Img2",
  ],
  date: "2025-11-29",
  status: "Pending",
};

const ClaimCard: React.FC<OrderCardProps> = ({
  orderId,
  amount,
  orderDate,
  items,
  shippingDetails,
  orderStatus,
  orderItems,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showClaimModal, setShowClaimModal] = useState(false);
  const [showDiscountModal, setShowDiscountModal] = useState(false); // NEW

  const claimInfo = dummyClaimInfo;

  return (
    <div
      className={`claim-card ${isExpanded ? "claim-card--expanded" : ""}`}
      // onClick={() => {
      //   // Only toggle if no modal is open
      //   if (!showDiscountModal && !showClaimModal) {
      //     setIsExpanded(!isExpanded);
      //   }
      // }}
    >
      <div className="claim-card__header">
        <div className="claim-card__icon">
          <CubeSvg />
        </div>
        <div className="claim-card__details">
          <p className="claim-card__id">
            Order {orderId.toString().slice(0, 8)}
          </p>
          <p className="claim-card__amount">Amount: ${amount.toFixed(2)}</p>
          <p className="claim-card__info">
            Order Date: {orderDate} &nbsp; Items: {items}
          </p>
        </div>
        <div className="claim-card__toggle">
          <div
            className={`claim-card__chevron ${
              isExpanded ? "claim-card__chevron--rotated" : ""
            }`}
            onClick={(e) => {
              e.stopPropagation();
              setShowDiscountModal(true);
            }}
            style={{ cursor: "pointer" }}
          >
            <ButtonDownSvg />
          </div>
        </div>
      </div>

      {/* Assign Discount Modal */}
      {showDiscountModal && (
        <Modal
          isOpen={showDiscountModal}
          onClose={() => setShowDiscountModal(false)}
        >
          <div className="discount-modal-content">
            <div
              className="claim-card__content"
              style={{ position: "relative" }}
            >
              {/* Claim Reason */}
              <div className="claim-card__reason">
                <strong>Reason:</strong> {claimInfo.reason}
                <span
                  className={`claim-card__status-tag ${
                    claimInfo.status === "Pending" ? "open" : "closed"
                  }`}
                >
                  {claimInfo.status === "Pending" ? "Open" : "Closed"}
                </span>
              </div>

              {/* Order Status */}
              <div className="claim-card__status">
                <ul>
                  {orderStatus.map((statusItem, index) => (
                    <div
                      className="card__status claim-card-details"
                      key={index}
                    >
                      {statusItem.status === "Description" && (
                        <p style={{ color: "#222", marginTop: 6 }}>
                          {claimInfo.details}
                        </p>
                      )}
                    </div>
                  ))}
                </ul>
              </div>

              {/* Order Items */}
              <div className="claim-card__items">
                <h4 className="ss">Attachments</h4>
                <div className="claim-card__item">
                  {orderItems.map((item, index) => (
                    <div key={index}>
                      <div className="claim-card__item left">
                        <img src={item.image || AboutImg} alt={item.name} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Discount Form */}
              <form
                className="discount-modal-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  // Handle submit logic here
                  setShowDiscountModal(false);
                }}
              >
                <div className="discount-modal-field">
                  <label htmlFor="discount-comment">Comment</label>
                  <textarea
                    id="discount-comment"
                    name="discountComment"
                    rows={3}
                    placeholder="Add a comment about this discount request..."
                    required
                  />
                </div>
                <div className="discount-modal-field">
                  <label htmlFor="discount-amount">Discount Amount</label>
                  <input
                    id="discount-amount"
                    name="discountAmount"
                    type="number"
                    min={0}
                    step={0.01}
                    placeholder="Enter amount"
                    required
                  />
                </div>
                <button type="submit" className="discount-modal-submit-btn">
                  Submit Request
                </button>
              </form>
            </div>
          </div>
        </Modal>
      )}

      {/* Claim Modal */}
      <ClaimModal
        isOpen={showClaimModal}
        onClose={() => setShowClaimModal(false)}
        onSubmit={(data) => {
          setShowClaimModal(false);
        }}
        productName={orderItems[0]?.name}
      />
    </div>
  );
};

export default ClaimCard;
